import React, { useEffect, useRef } from 'react';
import { createUseStyles } from 'react-jss';
import confetti from 'canvas-confetti';
import { useT } from '../../i18n';

const ROBOT_COLORS = ['#d94f2b', '#2a63a8', '#e0a325', '#2f9e6e'];
const MONO = 'ui-monospace, SFMono-Regular, Menlo, monospace';

const useStyles = createUseStyles({
  overlay: {
    position: 'fixed',
    inset: 0,
    zIndex: 100,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '24px',
    pointerEvents: 'none',
  },
  message: {
    background: '#2a1d13',
    border: '1px solid #6b4622',
    borderRadius: '12px',
    padding: '22px 34px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '6px',
    textAlign: 'center',
    boxShadow: [
      'inset 0 1px 0 rgba(255,255,255,0.14)',
      'inset 0 -3px 0 rgba(0,0,0,0.4)',
      '0 18px 50px rgba(0,0,0,0.55)',
    ].join(','),
    animation: '$fadeInUp 0.4s ease',
  },
  label: {
    fontFamily: MONO,
    color: '#d99a6a',
    fontSize: '10px',
    fontWeight: 700,
    letterSpacing: '3px',
    textTransform: 'uppercase',
  },
  name: {
    color: '#f5e6c8',
    fontSize: '24px',
    fontWeight: 700,
    letterSpacing: '1px',
  },
  '@keyframes fadeInUp': {
    '0%': { opacity: 0, transform: 'translateY(20px) scale(0.95)' },
    '100%': { opacity: 1, transform: 'translateY(0) scale(1)' },
  },
});

function CelebrationOverlay({ username, onDone }) {
  const classes = useStyles();
  const t = useT();
  const doneRef = useRef(onDone);
  doneRef.current = onDone;

  useEffect(() => {
    const duration = 2500;
    const end = Date.now() + duration;

    const frame = () => {
      confetti({
        particleCount: 3,
        angle: 60,
        spread: 55,
        origin: { x: 0, y: 0.6 },
        colors: ROBOT_COLORS,
      });
      confetti({
        particleCount: 3,
        angle: 120,
        spread: 55,
        origin: { x: 1, y: 0.6 },
        colors: ROBOT_COLORS,
      });

      if (Date.now() < end) requestAnimationFrame(frame);
    };
    frame();

    const timer = setTimeout(() => doneRef.current?.(), duration + 500);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className={classes.overlay}>
      <div className={classes.message}>
        <span className={classes.label}>{t('game.roundWonBy')}</span>
        <span className={classes.name}>{username}</span>
      </div>
    </div>
  );
}

export default CelebrationOverlay;
